module.exports = __webpack_public_path__ + "static/media/logo-short.41785072.png";